// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { GripVertical as RawGripVertical } from "lucide-react";
export const GripVertical = /* @__PURE__ */ createIcon(RawGripVertical, "GripVertical", 2);
